export const CONTRIBUTOR_DATA = [
  {
    name: 222,
    social1: 'twitter',
    username1: 'BCC_222',
    social2: 'instagram',
    username2: '__Radon__222__',
    social3: '',
    username3: '',
    song: 'Paranoia',
  },
  {
    name: 'aplusod',
    social1: 'tumblr',
    username1: 'aplusod',
    social2: '',
    username2: '',
    social3: '',
    username3: '',
    song: 'Chaining Intention',
  },
  {
    name: 'asterriism',
    social1: 'twitter',
    username1: 'asterriism',
    social2: 'instagram',
    username2: 'asterriism',
    social3: 'tumblr',
    username3: 'asterriism',
    song: 'Burenai Ai De',
  },
  {
    name: 'cakey39',
    social1: 'twitter',
    username1: 'cakey39',
    social2: 'bluesky',
    username2: 'cakey39',
    social3: 'instagram',
    username3: 'cakey39',
    song: 'Glow',
  },
  {
    name: 'carn_e_vil',
    social1: 'twitter',
    username1: 'carn_e_vil',
    social2: 'instagram',
    username2: 'carn.e.vil',
    social3: '',
    username3: '',
    song: 'Bacterial Contamination',
  },
  {
    name: 'Carrie',
    social1: 'instagram',
    username1: 'finalremixx',
    social2: 'tumblr',
    username2: 'anotherremixx',
    social3: '',
    username3: '',
    song: 'Triple Baka',
  },
  {
    name: 'Champy',
    social1: 'twitter',
    username1: 'champy_is_there',
    social2: '',
    username2: '',
    social3: '',
    username3: '',
    song: 'All I Need Are Things I Like',
  },
  {
    name: 'Clover',
    social1: 'twitter',
    username1: 'cloverwish__',
    social2: 'bluesky',
    username2: 'cloverwish',
    social3: 'instagram',
    username3: 'clover.wish',
    song: 'LoL -lots of laugh-',
  },
  {
    name: 'cmndrmuffin',
    social1: 'twitter',
    username1: 'cmndrmuffin',
    social2: '',
    username2: '',
    social3: '',
    username3: '',
    song: 'Love Trial',
  },
  {
    name: 'Corroded Concept',
    social1: 'twitter',
    username1: 'corrodedconcept',
    social2: 'instagram',
    username2: 'corrodedconcept',
    social3: '',
    username3: '',
    song: 'Tell Your World',
  },
  {
    name: 'Cthuwoo',
    social1: 'twitter',
    username1: 'CthuWoo',
    social2: 'bluesky',
    username2: 'cthuwoo',
    social3: 'instagram',
    username3: 'cthuwoo',
    song: 'Karakuri Pierrot',
  },
  {
    name: 'Dia',
    social1: 'twitter',
    username1: 'DiamondTeaaaa',
    social2: 'instagram',
    username2: 'diamondteaaaa',
    social3: '',
    username3: '',
    song: 'Electric Angel',
  },
  {
    name: 'Drasi',
    social1: 'twitter',
    username1: '_drasi',
    social2: 'bluesky',
    username2: 'drasi-grtsq',
    social3: 'instagram',
    username3: '__drasi',
    song: 'Cantarella',
  },
  {
    name: 'Echo',
    social1: 'twitter',
    username1: 'chartrocity',
    social2: 'bluesky',
    username2: 'chartrocity',
    social3: '',
    username3: '',
    song: 'Sleeping Beauty',
  },
  {
    name: 'Felix',
    social1: 'twitter',
    username1: 'gingkogun',
    social2: 'instagram',
    username2: 'gingkokun',
    social3: 'tumblr',
    username3: 'gingkokun',
    song: 'Crime And Punishment',
  },
  {
    name: 'florenstry',
    social1: 'twitter',
    username1: 'florenstry',
    social2: 'instagram',
    username2: 'florenstry_',
    social3: '',
    username3: '',
    song: "Leave In The Summer, Yet You're In My Fluffoughts",
  },
  {
    name: 'habba',
    social1: 'twitter',
    username1: 'habbaniceday',
    social2: '',
    username2: '',
    social3: '',
    username3: '',
    song: 'Odds & Ends',
  },
  {
    name: 'Hazuki',
    social1: 'twitter',
    username1: 'hazukied',
    social2: 'bluesky',
    username2: 'hazukied',
    social3: 'instagram',
    username3: 'hazukied',
    song: 'Front Cover',
  },
  {
    name: 'Hypo',
    social1: 'twitter',
    username1: 'xxHYPOxx',
    social2: 'instagram',
    username2: 'hypo_no_yume',
    social3: '',
    username3: '',
    song: 'World Is Mine',
  },
  {
    name: 'JAKMONX',
    social1: 'bluesky',
    username1: 'jakmonx',
    social2: 'instagram',
    username2: 'jakmonx',
    social3: '',
    username3: '',
    song: 'Saihate',
  },

  {
    name: 'Jester',
    social1: 'twitter',
    username1: 'yoursweetjester',
    social2: 'bluesky',
    username2: 'yoursweetjester',
    social3: 'instagram',
    username3: 'yoursweetjester',
    song: 'Fakery Tale',
  },
  {
    name: 'Kay',
    social1: 'twitter',
    username1: 'kaypxz',
    social2: 'instagram',
    username2: 'kay.pxz',
    social3: '',
    username3: '',
    song: 'Pinky Swear',
  },
  {
    name: 'keydromeda',
    social1: 'twitter',
    username1: 'keydr0meda',
    social2: 'instagram',
    username2: 'keydr0meda',
    social3: '',
    username3: '',
    song: 'Kusare Gedou to Chocolate',
  },
  {
    name: 'Kirisstar',
    social1: 'twitter',
    username1: 'kinaqua10',
    social2: 'instagram',
    username2: 'kirisstars',
    social3: 'tiktok',
    username3: 'kirisstar_',
    song: 'PartyxParty',
  },
  {
    name: 'Laboon_dawhale',
    social1: 'instagram',
    username1: 'Laboon_dawhale',
    social2: 'tiktok',
    username2: 'Laboon_whalesquids',
    social3: 'youtube',
    username3: 'Laboon-whalesquids',
    song: 'Lillia & Skeleton Orchestra',
  },
  {
    name: 'Lyss',
    social1: 'twitter',
    username1: 'lyssist',
    social2: '',
    username2: '',
    social3: '',
    username3: '',
    song: 'Rolling Girl',
  },
  {
    name: 'maguro',
    social1: 'twitter',
    username1: 'magurosnacks',
    social2: 'instagram',
    username2: 'maguro',
    social3: '',
    username3: '',
    song: 'When First Love Ends',
  },
  {
    name: 'Megan',
    social1: 'instagram',
    username1: 'pandarox123',
    social2: '',
    username2: '',
    social3: '',
    username3: '',
    song: 'Ohedo Julia Night',
  },
  {
    name: 'meowbot39',
    social1: 'twitter',
    username1: 'meowbot39',
    social2: 'instagram',
    username2: 'meowbot39',
    social3: 'tumblr',
    username3: 'meowbot39',
    song: 'Rotten Girl, Grotesque Romance',
  },
  {
    name: 'metgalactic',
    social1: 'bluesky',
    username1: 'metgalactic',
    social2: 'youtube',
    username2: 'metgalactic',
    social3: '',
    username3: '',
    song: 'Magnet',
  },
  {
    name: 'mieledoll',
    social1: 'twitter',
    username1: 'mieledoll',
    social2: 'instagram',
    username2: 'mieledoll',
    social3: 'tumblr',
    username3: 'mieledoll',
    song: 'Love Colored Ward',
  },
  {
    name: 'Natalie Haku',
    social1: 'twitter',
    username1: 'NatalieHaku',
    social2: 'instagram',
    username2: 'NatalieHaku',
    social3: 'tumblr',
    username3: 'NatalieHaku',
    song: '01 Ballad',
  },
  {
    name: 'nena',
    social1: 'twitter',
    username1: 'ichini39',
    social2: '',
    username2: '',
    social3: '',
    username3: '',
    song: 'The Intense Voice of Hatsune Miku',
  },
  {
    name: 'Neron',
    social1: 'twitter',
    username1: 'neronhelvetios',
    social2: '',
    username2: '',
    social3: '',
    username3: '',
    song: 'Yellow',
  },
  {
    name: 'Nic_oxxo',
    social1: 'twitter',
    username1: 'nic_oxxo',
    social2: 'instagram',
    username2: 'nic_o.x',
    social3: '',
    username3: '',
    song: 'Po Pi Po',
  },
  {
    name: 'Nyansae',
    social1: 'twitter',
    username1: 'nyansae01',
    social2: 'instagram',
    username2: 'nyansae',
    social3: 'tumblr',
    username3: 'nyansae',
    song: 'Summer Idol',
  },
  {
    name: 'RORUUA',
    social1: 'twitter',
    username1: 'RORUUA',
    social2: 'instagram',
    username2: 'RORUUA',
    social3: '',
    username3: '',
    song: 'Strobe Light',
  },
  {
    name: 'saderuuu',
    social1: 'twitter',
    username1: 'saderuuu',
    social2: 'bluesky',
    username2: 'saderuuu',
    social3: 'instagram',
    username3: 'saderuuu',
    song: 'Matryoshka',
  },
  {
    name: 'SADHA',
    social1: 'twitter',
    username1: 'sadhaart',
    social2: 'bluesky',
    username2: 'sadhaart',
    social3: 'instagram',
    username3: 'sadha.art',
    song: 'Unhappy Refrain',
  },
  {
    name: 'Sheepie',
    social1: 'twitter',
    username1: 'meeksheepie',
    social2: 'instagram',
    username2: 'meeksheepie',
    social3: '',
    username3: '',
    song: 'Sand Planet',
  },
  {
    name: 'Sloth',
    social1: 'twitter',
    username1: 'DDrawsb',
    social2: 'instagram',
    username2: 'drag.draws',
    social3: 'tumblr',
    username3: 'dragdraws-art',
    song: 'Satisfaction',
  },
  {
    name: 'spherafim',
    social1: 'twitter',
    username1: 'spherafim',
    social2: 'instagram',
    username2: 'spherafim',
    social3: '',
    username3: '',
    song: 'Nice To Meet You, Mr. Earthling',
  },
  {
    name: 'thel0llip0p',
    social1: 'twitter',
    username1: 'thel0llip0p',
    social2: 'instagram',
    username2: 'thel0llip0p',
    social3: '',
    username3: '',
    song: 'Deep Sea Girl',
  },
  {
    name: 'tomatetoro',
    social1: 'twitter',
    username1: 'tomatetoro',
    social2: 'bluesky',
    username2: 'tomatetoro',
    social3: '',
    username3: '',
    song: 'Cat Food',
  },
  {
    name: 'Velvetterabby',
    social1: 'twitter',
    username1: 'velvetterabby',
    social2: 'instagram',
    username2: 'velvetterabby',
    social3: 'tumblr',
    username3: 'velvetterabby',
    song: 'Romeo & Cinderella',
  },
];
